import { Box, Button } from '@mui/material';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { BusinessStoreOrderDeatils } from '../BusinessOrderVerify';

const TABLE_PAGE_SIZE = 10;
const API_BATCH_SIZE = 1000;
const PAGES_PER_BATCH = API_BATCH_SIZE / TABLE_PAGE_SIZE;
type PaginationState = {
  pageIndex: number;
  pageSize: number;
};
type PaginationUpdater = PaginationState | ((previous: PaginationState) => PaginationState);
type BusinessOrderUnverifyListProps = {
  columns: MRT_ColumnDef<BusinessStoreOrderDeatils>[];
  tableData: BusinessStoreOrderDeatils[];
  OrderType: { Business: string };
  businessId: string;
  businessStoreId: string;
  departmentId: string;
  orderId: string;
  IsLoading: boolean;
  refreshTrigger: number;
  fetchBusinessOrder: (id: string, pageNum?: number, pageSize?: number) => void;
  fetchBusinessStoreOrder: (id: string, pageNum?: number, pageSize?: number) => void;
  fetchBusinessDepartmentOrder: (id: string, pageNum?: number, pageSize?: number) => void;
};

export const BusinessOrderUnverifyList = (Props: BusinessOrderUnverifyListProps) => {
    const navigate = useNavigate();
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: TABLE_PAGE_SIZE,
    });

    const currentApiPage = Math.floor(pagination.pageIndex / PAGES_PER_BATCH);
    const isLastBatch = Array.isArray(Props?.tableData) && Props.tableData.length < API_BATCH_SIZE;
    const dynamicRowCount = isLastBatch
      ? currentApiPage * API_BATCH_SIZE + (Props?.tableData?.length || 0)
      : (currentApiPage + 1) * API_BATCH_SIZE + 1;

    const handlePaginationChange = (updater: PaginationUpdater) => {
      const nextPagination = typeof updater === 'function' ? updater(pagination) : updater;
      const oldApiPage = Math.floor(pagination.pageIndex / PAGES_PER_BATCH);
      const targetApiPage = Math.floor(nextPagination.pageIndex / PAGES_PER_BATCH);

      setPagination(nextPagination);

      if (targetApiPage !== oldApiPage) {
        if (Props?.departmentId && Props?.businessStoreId) {
          Props.fetchBusinessDepartmentOrder(Props.departmentId, targetApiPage, API_BATCH_SIZE);
        } else if (Props?.businessStoreId) {
          Props.fetchBusinessStoreOrder(Props.businessStoreId, targetApiPage, API_BATCH_SIZE);
        } else if (Props?.businessId) {
          Props.fetchBusinessOrder(Props.businessId, targetApiPage, API_BATCH_SIZE);
        }
      }
    };

    const slicedTableData = useMemo(() => {
      if (!Array.isArray(Props?.tableData)) {
        return [];
      }

      const startIndex = (pagination.pageIndex % PAGES_PER_BATCH) * pagination.pageSize;
      return Props.tableData.slice(startIndex, startIndex + pagination.pageSize);
    }, [Props?.tableData, pagination.pageIndex, pagination.pageSize]);

    useEffect(() => {
      setPagination({ pageIndex: 0, pageSize: TABLE_PAGE_SIZE });
    }, [Props?.businessId, Props?.businessStoreId, Props?.departmentId, Props?.orderId, Props?.refreshTrigger]);

    return (
      <div style={{padding:"5px 15px"}}>
      <MaterialReactTable
          state={{ pagination }}
          onPaginationChange={handlePaginationChange}
          manualPagination
          rowCount={dynamicRowCount}
          displayColumnDefOptions={{
            'mrt-row-actions': {
              muiTableHeadCellProps: {
                align: 'center',
              },
              size: 100,
            },
          }}
          muiTableContainerProps={{
            sx: {
              height: '60vh',
            },
          }}
          muiTablePaperProps={{
            sx: {
              width: '100%',
              '& .css-1tbggly': {
                minHeight: '2px',
              },
            },
          }}
          localization={{noRecordsToDisplay: Props?.businessStoreId && Props?.businessId && Props?.departmentId || Props?.orderId && Props?.businessId ? 'No data Available' : 'Select a business & business store & department to display records'}}
          columns={Props?.columns}
          data={slicedTableData}
          initialState={{ pagination: { pageSize: TABLE_PAGE_SIZE, pageIndex: 0 } }}
          editDisplayMode="cell" // ('modal', 'row', 'cell', and 'custom' are also available)
          enableEditing
          positionActionsColumn="last"
          enableRowActions
          enableFullScreenToggle={false}
          enableExpandAll={false}
          enableHiding={false}
          enableColumnFilters={false}
          enableToolbarInternalActions={false}
          enableStickyHeader
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Button
                variant="contained"
                onClick={() => {
                  navigate('order-details-verify', {
                    state: {
                      orderType: Props?.OrderType.Business,
                      order: row?.original,
                    },
                  });
                }}
              >
                Verify
              </Button>
            </Box>
          )}
        />
      </div>
  
    )
}